module.exports = {
  DISTANCE: 'distance',
  PRICE: 'cost',
  DURATION: 'duration',
  DURATION_IN_TRAFFIC: 'duration-in-traffic',
};
